export function normalizeAssignedToUserIds(value: string | string[] | undefined): string[] {
  if (Array.isArray(value)) return value.map((id) => id.trim()).filter(Boolean);
  if (typeof value === 'string' && value.trim()) return [value.trim()];
  return [];
}

export function formatAssignedToUserChipValue(
  ids: string[],
  labelForId: (id: string) => string
): string {
  if (ids.length === 0) return '';
  if (ids.length === 1) return labelForId(ids[0]!);
  return ids.map(labelForId).join(', ');
}
